module.exports = __webpack_public_path__ + "static/img/kefu_online.59893e79.png";